import React, { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { faPencilAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import InputComponent from '../../Customer/AddCustomers/InputComponent';
import middleware from '../../Api/Middleware';
import ToastError from '../../Toasts/ToastError';
import ToastInfo from '../../Toasts/ToastInfo';
import ToastSuccess from '../../Toasts/ToastSuccess';
import { BorderedTextInput } from '../../HouseStyle/Components/Inputs';
import { BorderedDropDown } from '../../HouseStyle/Components/DropDowns';

const AddEmailModal = (props) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: "", type: "0" });


    const addEmail = async () => {
        let emailRes = await middleware.post("/emails", {
            internal_id: props.customer.internal_id,
            email: formData.email,
        });
        const newEmail = emailRes.data.data;

        ToastSuccess("Email is aangemaakt");
        props.setSelectedEmail(newEmail);

        if (props?.order.client_emails) {
            props.setOrder({ ...(props.order), client_emails: [...props.order.client_emails, newEmail] });
        } else {
            props.setEmails([...props.emails, newEmail]);
        }
        props.setAddEmailModalVisible(false);
    }

    const handleClose = () => {
        props.setAddEmailModalVisible(false);
    };
    return (
        <Modal
            id="modalItemNote"
            show={props.addEmailModalVisible}
            onHide={handleClose}
            className="colormodals"
            size="xl"
            centered
        >
            <Modal.Header className="modalTop justify-content-between" >
                <h4 className="mb-0 fw-semibold">E-mail toevoegen</h4>
                <button variant="transparent" className=' btn' onClick={() => { props.setAddEmailModalVisible(false) }}>
                    <FontAwesomeIcon icon={faXmark} className="closeModal" />
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter d-flex flex-column">
                <div className="">
                    <div>
                        <div className="mb-4">
                            <BorderedDropDown
                                placeholder='Type'
                                selectedValue={formData.type}
                                setSelectedValue={(e) => setFormData({ ...formData, type: e })}
                                options={[
                                    { value: '0', title: "Normaal" },
                                    { value: '1', title: "Factuur" }
                                ]}
                                label={"Type"}
                            />
                        </div>

                        <div className="mb-4">
                            <BorderedTextInput
                                inputValue={formData.email}
                                setInputValue={(e) => {
                                    const value = e && e.target ? e.target.value : e;
                                    setFormData({ ...formData, email: value });
                                }}
                                placeholder='test@test.nl'
                                label={"E-mail"}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="modalBottom">
                   <div className="d-flex justify-content-between">
                        <button className="btn DarkStandardButton" type="button" onClick={() => { props.setAddEmailModalVisible(false) }}>Annuleren</button>
                        <button className="btn lightBlueStandardButton" onClick={() => addEmail()}>{"Toevoegen"}</button>
                    </div>
            </Modal.Footer>
        </Modal>
    )
}

export default AddEmailModal
